(function() {
    'use strict';
    /*
     * Copyright (c) 2014 In Hand Health.
     * All rights reserved.
     */

    angular
        .module('ihh-common-web')
        .controller('PtihLoginWaitCtrl', PtihLoginWaitCtrl);

    PtihLoginWaitCtrl.$inject = ['$scope', '$modalInstance'];

    /**
     * Controller for a modal wait dialog with a single button to make it go away.
     */
    function PtihLoginWaitCtrl($scope, $modalInstance) {
        /**
         * Closes the dialog with an negative (Cancel) choice.
         */
        $scope.cancel = function() {
            $modalInstance.dismiss('cancel');
        };
    }
})();